import { createSlice } from "@reduxjs/toolkit";

const logsSlice = createSlice({
    name: "logs",
    initialState: [],
    reducers: {
        addLog: (state, action) => {
            state.push(action.payload);
        },
        clearLogs: (state) => {
            return []; // Clear all logs
        },
    },
});

export const { addLog, clearLogs } = logsSlice.actions;
export default logsSlice.reducer;